// src/monitoring/MonitoringDispatcher.tsx
"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { resolvePageKey } from "./page-key";
import { setTelemetryContext } from "./telemetry-context";
import { registerGlobalErrorTracking } from "./register-errors";
import { registerWebVitals } from "./report-web-vitals";

type Props = {
  sampleRateByPageKey?: Partial<Record<string, number>>;
};

export function MonitoringDispatcher({ sampleRateByPageKey }: Props) {
  const pathname = usePathname();

  useEffect(() => {
    const pageKey = resolvePageKey(pathname);
    // console.log(`pageKey: ${pageKey}`);
    // console.log(`pathname: ${pathname}`);
    if (!pageKey) return;

    const pathNoLang = pathname.replace(/^\/[a-z]{2}(\/|$)/, "/");
    const sampleRate = sampleRateByPageKey?.[pageKey];

    setTelemetryContext({
      pageKey,
      route: pathNoLang,
      sampleRate,
    });

    const cleanupErrors = registerGlobalErrorTracking();
    const cleanupVitals = registerWebVitals();

    return () => {
      cleanupVitals?.();
      cleanupErrors?.();
    };
  }, [pathname, sampleRateByPageKey]);

  return null;
}
